const user_id = (state) => {
    return state.user_id
}
const favcount = (state) => {
    return state.favcount
}
const comparecount = (state) => {
    return state.comparecount
}
const compareinfo = (state) => {
    return state.compareinfo
}
const firms = (state) => {
    return state.firms
}
const firmDefaultId = (state) => {
    return state.firm_default_id
}
const validation = (state) => {
    return state.validation;
}
const current_message = (state) => {
    return state.message;
}

export default {
    user_id,
    favcount,
    comparecount,
    compareinfo,
    firms,
    firmDefaultId,
    validation,
    current_message,
}
